import {Component, Input } from '@angular/core';
import { NgbModal, NgbActiveModal, ModalDismissReasons } from '@ng-bootstrap/ng-bootstrap';

@Component({
  templateUrl: './confirmationModal.component.html',
})
export class ConfirmacionModalComponent {
  @Input() titulo;
  @Input() contenido;

  constructor(private modal: NgbModal, private activeModal: NgbActiveModal) {
  }

  confirmar() {
    this.activeModal.close();
  }

  dismiss() {
      this.activeModal.dismiss();
  }
}



// WEBPACK FOOTER //
// D:/a/1/s/BackOffice/SOC/SxSoc.ClientWeb/src/app/helpers/components/confirmationModal/confirmationModal.component.ts